import React from 'react';

import './WhyChoice.scss';

import {
  IconMegaPhone,
  IconDiscountBag,
  IconLifeBuoy,
  IconPieChart,
} from '../../../../assets/index';

const menu = [
  {
    id: 0,
    icon: <IconMegaPhone />,
    title: 'Công cụ Quảng cáo Miễn phí',
    desc: 'Chọn một loạt các giải pháp để thúc đẩy chuyển đổi từ trang web của bạn.',
  },
  {
    id: 1,
    icon: <IconDiscountBag />,
    title: 'Chia sẻ doanh thu lên đến 15% kèm theo Thưởng Doanh Số.',
    desc: 'Nhận lại 15% doanh thu từ Mytour cho mỗi đơn hàng thành công',
  },
  {
    id: 2,
    icon: <IconLifeBuoy />,
    title: 'Tích hợp đơn giản',
    desc: 'Chỉ mất vài phút để thiết lập',
  },
  {
    id: 3,
    icon: <IconPieChart />,
    title: 'Thanh toán rõ ràng, minh bạch',
    desc: 'Cập nhật đơn hàng theo thời gian thực, chi tiết theo từng chiến dịch',
  },
];
const WhyChoice = () => {
  return (
    <div className='WhyChoice'>
      <div className='title'>
        Vì sao tôi nên tham gia <br />
        Chương trình đối tác của Mytour
        <div className='line' />
      </div>

      <div className='wrapListItem'>
        {menu.map((el, index) => (
          <div className='item' key={index}>
            <div className='icon'>{el.icon}</div>
            <div className='title'>{el.title}</div>
            <div className='desc'>{el.desc}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhyChoice;
